/**
 * @readonly
 * @enum {string}
 */
module.exports = {
    // one organisation with multiple offices - offices are handled separately
    FRANCHISE: 'franchise',
    // one organisation with multiple offices (shared clients, lecturers, stats etc.)
    ALL_IN: 'all_in',
    // one organisation with one office
    STANDALONE: 'standalone',
};
